<div class="admin-wizard-controls">
  <ComboBox
    @value={{this.wizardListVal}}
    @content={{this.wizardList}}
    @onChange={{route-action "changeWizard"}}
    @options={{hash none="admin.wizard.select"}}
  />
  <DButton
    @action={{route-action "createWizard"}}
    @label="admin.wizard.create"
    @icon="plus"
  />
</div>

<WizardMessage
  @key={{this.messageKey}}
  @url={{this.messageUrl}}
  @component="wizard"
/>

<div class="admin-wizard-container settings">
  {{outlet}}
</div>